export default __webpack_public_path__ + "static/media/jeep-wrap-1.6b54e8c2.png";